import { TComponentConfig, IDateCommonSelectType } from '../types';
import { getDateDefaultValue } from '../utils';
import MultiDateSelect, { TMultiDateSelect } from '../widgets/MultiDateSelect';
import SingleDateSelect from '../widgets/SingleDateSelect';

export const SingleDateRange: TComponentConfig<TMultiDateSelect> = {
  Component: SingleDateSelect,
  props: {
    valueKeys: {
      start_time: 'start_time',
      end_time: 'end_time',
      date_type: 'date_type',
    },
  },
  defaultValue: (filterValue: any, props: IDateCommonSelectType) => {
    return getDateDefaultValue(filterValue, props, true);
  },
};

export const MultiDateRange: TComponentConfig<TMultiDateSelect> = {
  Component: MultiDateSelect,
  props: {
    valueKeys: {
      start_time: 'start_time',
      end_time: 'end_time',
      date_type: 'date_type',
    },
  },
  defaultValue: (filterValue: any, props: IDateCommonSelectType) => {
    return getDateDefaultValue(filterValue, props);
  },
};
